import React, { useEffect, useState } from "react";
import app, { setUserFbLogin } from "../firebase";
import Api from "../../lib/componentApi";
const ENV = process.env.ENV;
export const useFirebaseForTrack = orderUid => {
  const [trackData, setTrackData] = useState({});
  const [user, setUser] = useState(null);
  useEffect(() => {
    const unlisten = app.auth().onAuthStateChanged(authUser => {
      setUser(authUser);
    });
    return () => {
      unlisten();
    };
  });
  const getDb = () => {
    if (ENV === "MASTER") {
      return "master";
    } else if (ENV === "TEST") {
      return "staging";
    } else {
      return "dev";
    }
  };
  useEffect(() => {
    if (user) {
      const dbRoot = app.database().ref(`/${getDb()}/users/${user.uid}`);
      dbRoot.on("value", snap => {
        if (snap.val()) {
          const allData = snap.val();
          const trackOrder =
            (allData && allData.orders && allData.orders[orderUid]) || {};

          setTrackData(trackOrder);
        }
      });

      return () => dbRoot.off("value");
    }
  }, [user]);

  useEffect(() => {
    function signInFirebase() {
      Api.post("/api/firebase-token", {}, (response, errors) => {
        if (response) {
          setUserFbLogin(response);
        }
      });
    }
    if (!user) {
      signInFirebase();
    }
  }, [user]);

  return { trackData, user };
};
